
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { BackButton } from "@/components/BackButton";
import { useTheme } from "@/contexts/ThemeContext";
import { motion } from "framer-motion";

const TermsConditions = () => {
  const { colors } = useTheme();

  return (
    <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: colors.background }}>
      <Navigation />
      <div className="pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <BackButton />
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="prose prose-lg max-w-none"
            style={{ color: colors.foreground }}
          >
            <h1 className="text-4xl font-bold mb-8" style={{ color: colors.foreground }}>
              Terms & Conditions
            </h1>
            
            <p className="text-sm mb-8" style={{ color: colors.secondary }}>
              Last Updated: June 23, 2025
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Interpretation and Definitions
              </h2>
              <p style={{ color: colors.secondary }}>
                In this agreement, "Company" refers to Agape Entertainment, located in Chennai, Tamil Nadu, India. "You" refers to the individual or entity accessing our services. "Device" includes any equipment—computers, smartphones, or tablets—used to access the Service. "Service" means the creative, digital, marketing, and anti-piracy solutions offered by the Company. All capitalized terms retain consistent meanings whether in singular or plural form.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Acknowledgment
              </h2>
              <p style={{ color: colors.secondary }}>
                These Terms and Conditions constitute a binding agreement between You and the Company. By accessing or using our Service, you agree to abide by these Terms and confirm that you are at least 18 years old. If you do not agree, please discontinue use. Acceptance also implies agreement with our Privacy Policy, which outlines how your personal data is collected, used, and protected.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Links to Other Websites
              </h2>
              <p style={{ color: colors.secondary }}>
                Our platform may include links to external websites not operated by us. We hold no responsibility for their content or privacy practices. Access to third-party sites is at your own risk, and we advise reviewing their terms independently.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Security of Your Personal Data
              </h2>
              <p style={{ color: colors.secondary }}>
                We implement reasonable safeguards—such as encryption and access controls—to protect your personal information. While no system is entirely secure, we regularly update our protocols to minimize risks. Your trust and data security remain a top priority.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Children's Privacy
              </h2>
              <p style={{ color: colors.secondary }}>
                Our services are not intended for users under 13. If we become aware of data collected from a child, we will take prompt action to remove it. Parental supervision is encouraged for online activity involving minors.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Governing Law
              </h2>
              <p style={{ color: colors.secondary }}>
                These Terms are governed by the laws of Tamil Nadu, India. Any disputes will be handled under the jurisdiction of courts in Chennai. International users must comply with applicable local laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: colors.foreground }}>
                Contact Us
              </h2>
              <p style={{ color: colors.secondary }}>
                For any concerns or inquiries, you can reach us through the following channels: Email:{" "}
                <a href="mailto:info@agapeentertainment.in" className="underline" style={{ color: colors.primary }}>
                  info@agapeentertainment.in
                </a>{" "}
                for prompt assistance, or directly at our office. You are also welcome to visit us at our office located at Chennai, where we will be happy to assist you in person.
              </p>
            </section>
          </motion.div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
